// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5532":"01f9a192","5931":"977c7a05","6066":"d6fb1e1d"}[chunkId] + ".chunk.css";
};